module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGGyumaoC-7c052c900fd2619d98ea83fb797cf2d3.png";